import React from 'react';
import propTypes from 'prop-types';
export const ScaleIcon = ({ size, color, variant }) => {
  const sizeInPixel = `${size}px`;
  return (
    <svg
      width={sizeInPixel}
      height={sizeInPixel}
      className={variant}
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 24 24"
      version="1.1"
    >
      <g id="surface1">
        <path
          stroke="none"
          fillRule="nonzero"
          fill={color}
          fillOpacity="1"
          d="M 9.601562 15 C 9.601562 14.390625 9.648438 14.671875 6.410156 8.195312 C 5.75 6.867188 3.851562 6.867188 3.1875 8.195312 C -0.078125 14.726562 0 14.414062 0 15 C 0 16.65625 2.148438 18 4.800781 18 C 7.453125 18 9.601562 16.65625 9.601562 15 Z M 4.800781 9 L 7.5 14.398438 L 2.101562 14.398438 Z M 24 15 C 24 14.390625 24.046875 14.671875 20.8125 8.195312 C 20.148438 6.867188 18.25 6.867188 17.589844 8.195312 C 14.320312 14.726562 14.398438 14.414062 14.398438 15 C 14.398438 16.65625 16.546875 18 19.199219 18 C 21.851562 18 24 16.65625 24 15 Z M 16.5 14.398438 L 19.199219 9 L 21.898438 14.398438 Z M 19.800781 19.199219 L 13.199219 19.199219 L 13.199219 8.148438 C 14.082031 7.761719 14.742188 6.96875 14.9375 6 L 19.800781 6 C 20.132812 6 20.398438 5.734375 20.398438 5.398438 L 20.398438 4.199219 C 20.398438 3.867188 20.132812 3.601562 19.800781 3.601562 L 14.386719 3.601562 C 13.839844 2.875 12.976562 2.398438 12 2.398438 C 11.023438 2.398438 10.160156 2.875 9.613281 3.601562 L 4.199219 3.601562 C 3.867188 3.601562 3.601562 3.867188 3.601562 4.199219 L 3.601562 5.398438 C 3.601562 5.734375 3.867188 6 4.199219 6 L 9.0625 6 C 9.257812 6.96875 9.917969 7.761719 10.800781 8.148438 L 10.800781 19.199219 L 4.199219 19.199219 C 3.867188 19.199219 3.601562 19.46875 3.601562 19.800781 L 3.601562 21 C 3.601562 21.332031 3.867188 21.601562 4.199219 21.601562 L 19.800781 21.601562 C 20.132812 21.601562 20.398438 21.332031 20.398438 21 L 20.398438 19.800781 C 20.398438 19.46875 20.132812 19.199219 19.800781 19.199219 Z M 19.800781 19.199219 "
        />
      </g>
    </svg>
  );
};
ScaleIcon.prototype = {
  size: propTypes.number,
  color: propTypes.string,
  variant: propTypes.string,
};
ScaleIcon.defaultProps = {
  size: 18,
  color: 'black',
  varient: '',
};
